module.exports = __webpack_public_path__ + "img/reservisten.2a481038.svg";